import type { UpdateSensorPayload } from '@jums-dashboard/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { callFunction } from '@/lib/callableClient';

import { sensorsQueryKey } from './useSensors';

export default function useUpdateSensor() {
  const qc = useQueryClient();
  return useMutation<{ ok: true }, Error, UpdateSensorPayload>({
    mutationFn: (payload) => callFunction<UpdateSensorPayload, { ok: true }>('updateSensorCallable', payload),
    onSuccess: (_data, vars) => {
      toast.success('Sensor updated.');
      void qc.invalidateQueries({ queryKey: sensorsQueryKey(vars.homeId) });
    },
    onError: (err) => {
      toast.error(err.message || 'Failed to update sensor.');
    },
  });
}
